import { render, staticRenderFns } from "./UserPermissions.vue?vue&type=template&id=79f41b80&scoped=true&"
import script from "./UserPermissions.vue?vue&type=script&lang=js&"
export * from "./UserPermissions.vue?vue&type=script&lang=js&"
import style0 from "./UserPermissions.vue?vue&type=style&index=0&id=79f41b80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f41b80",
  null
  
)

export default component.exports